import { API_PDC_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const consentsConstants = {
  REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_START: "REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_START",
  REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_SUCCESS: "REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_SUCCESS",
  REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_ERROR: "REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_ERROR",
  GET_TSPAY_CONSENTS_ACCOUNTS_START: "GET_TSPAY_CONSENTS_ACCOUNTS_START",
  GET_TSPAY_CONSENTS_ACCOUNTS_SUCCESS: "GET_TSPAY_CONSENTS_ACCOUNTS_SUCCESS",
  GET_TSPAY_CONSENTS_ACCOUNTS_ERROR: "GET_TSPAY_CONSENTS_ACCOUNTS_ERROR",
  REQUEST_TSPAY_CONSENTS_RECURRING_START: "REQUEST_TSPAY_CONSENTS_RECURRING_START",
  REQUEST_TSPAY_CONSENTS_RECURRING_SUCCESS: "REQUEST_TSPAY_CONSENTS_RECURRING_SUCCESS",
  REQUEST_TSPAY_CONSENTS_RECURRING_ERROR: "REQUEST_TSPAY_CONSENTS_RECURRING_ERROR ",
  CLEAR_CONSENT_ACCOUNT: "CLEAR_CONSENT_ACCOUNT"
};

export function requestConsentsToAccountsList(
  auth, accountantUuid, companyUuid, providerId, productCode, accountNature, uuid
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: consentsConstants.REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V1}/pay/consents/accountsList`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          managerId: accountantUuid,
          itemId: companyUuid,
          providerId: providerId,
          productCode: productCode,
          accountNature: accountNature,
          tppRedirectUri: `${window.location.origin.replace("localhost", "127.0.0.1")}${
            window.location.pathname
          }#/tspayConsentsAccountsListCompleted?uuid=${uuid}`
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: consentsConstants.REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: consentsConstants.REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function clearConsentsAccounts() {
  return (dispatch) => {
    return new Promise(() => {
      dispatch({
        type: consentsConstants.CLEAR_CONSENT_ACCOUNT
      });
    });
  };
}

export function getConsentsAccounts(
  auth, accountantUuid, companyUuid, consentId
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: consentsConstants.GET_TSPAY_CONSENTS_ACCOUNTS_START
      });

      let request = {
        method: "GET",
        url: `${API_PDC_URL_V1}/pay/consents/${consentId}/accounts?itemId=${companyUuid}&managerId=${accountantUuid}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: consentsConstants.GET_TSPAY_CONSENTS_ACCOUNTS_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: consentsConstants.GET_TSPAY_CONSENTS_ACCOUNTS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function requestConsentsRecurring(
  auth, accountantUuid, companyUuid, providerId, productCode, accountAccess
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: consentsConstants.REQUEST_TSPAY_CONSENTS_RECURRING_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V1}/pay/consents/recurring`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
        data: {
          managerId: accountantUuid,
          itemId: companyUuid,
          providerId: providerId,
          productCode: productCode,
          accountAccess: accountAccess,
          tppRedirectUri: `${window.location.origin.replace("localhost", "127.0.0.1")}${window.location.pathname}#/tspayConsentsRecurringCompleted`
        }
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          dispatch({
            type: consentsConstants.REQUEST_TSPAY_CONSENTS_RECURRING_SUCCESS,
            payload: result.data
          });
          resolve(result.data);
        })
        .catch((response) => {
          dispatch({
            type: consentsConstants.REQUEST_TSPAY_CONSENTS_RECURRING_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
